'use client';

import { useAssetDetailsDataContext } from './AssetDetailsDataContext/AssetDetailsDataContext.use-client';
import { PerformanceDisclaimerBanner } from '../../performance-disclaimers/components/PerformanceDisclaimerBanner.use-client';
import {
  timeAmountToPeriodKey,
  resolvePeriodText,
} from '../../performance-disclaimers/utils/periodMapping';
import { PerformanceDisclaimerTranslations } from '../../performance-disclaimers/types';

interface AssetDetailsChartDisclaimerProps {
  translations: PerformanceDisclaimerTranslations;
  /** Optional className forwarded to the banner wrapper, e.g. to override padding. */
  className?: string;
}

const AssetDetailsChartDisclaimer = ({
  translations,
  className,
}: AssetDetailsChartDisclaimerProps) => {
  const { timeRange } = useAssetDetailsDataContext();

  const periodKey = timeAmountToPeriodKey[timeRange];

  const period = resolvePeriodText(periodKey, translations);

  return (
    <PerformanceDisclaimerBanner
      translations={translations}
      variant="dynamic"
      period={period}
      className={className}
    />
  );
};

export { AssetDetailsChartDisclaimer };
